"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstructorSignupController = /** @class */ (function () {
    function InstructorSignupController(UsersModel, FlashService, SchoolsModel, $state) {
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.SchoolsModel = SchoolsModel;
        this.$state = $state;
        this.submitted = false;
        this.schoolCodeValid = false;
        this.schoolInvalidMessage = "";
        this.instructor = {};
    }
    InstructorSignupController.prototype.formValid = function () {
        return this.schoolCodeValid === true;
    };
    InstructorSignupController.prototype.formatCode = function () {
        this.instructor.schoolcode = this.instructor.schoolcode
            .replace(/[^a-z0-9\s]/gi, "")
            .toUpperCase();
    };
    InstructorSignupController.prototype.getSchool = function () {
        var _this = this;
        this.clearInvalidMessage();
        this.FlashService.clearFlash();
        this.schoolCodeValid = false;
        this.SchoolsModel.getSchoolByCode(this.instructor.schoolcode).then(function (response) {
            if (response.schoolId) {
                _this.instructor.school = response.school;
                _this.school = response.school;
                _this.clearInvalidMessage();
                _this.schoolCodeValid = true;
            }
            else {
                _this.schoolInvalidMessage = response.message;
                _this.schoolCodeValid = false;
            }
        });
    };
    InstructorSignupController.prototype.clearInvalidMessage = function () {
        this.schoolInvalidMessage = "";
    };
    InstructorSignupController.prototype.submitInstructor = function () {
        var _this = this;
        if (this.submitted === true) {
            return;
        }
        this.submitted = true;
        var request = {
            firstname: this.instructor.firstname,
            lastname: this.instructor.lastname,
            username: this.instructor.username,
            password: this.instructor.password,
            email: this.instructor.email,
            phone: this.instructor.phone,
            schoolcode: this.instructor.schoolcode,
        };
        this.UsersModel.signupInstructor(request)
            .then(function (response) {
            _this.submitted = false;
            _this.$state.go("drivecoach.login");
            _this.FlashService.setMessage({
                type: "success",
                message: response.message || "Account created successfully! Please log in.",
            });
        })
            .catch(function () {
            _this.submitted = false;
        });
    };
    return InstructorSignupController;
}());
InstructorSignupController.$inject = [
    "UsersModel",
    "FlashService",
    "SchoolsModel",
    "$state",
];
exports.default = InstructorSignupController;
